import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 16px 0;

  overflow-y: auto;

  @media (min-width: 768px) {
    padding: 0px;
  }
`

export const Section = styled.section`
  width: 100%;
  margin-bottom: 32px;

  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 0px 100px;
  }
`

export const SectionTitle = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray900};

  margin-bottom: 16px;

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.medium};
    margin-bottom: 24px;
  }
`

export const SectionContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const FilterContainer = styled.div`
  position: relative;

  width: 100%;
  margin: 16px 0;

  .search-doctors-container {
    top: 100%;
    left: 0;
    z-index: 1;

    width: 100%;

    @media (min-width: 768px) {
      width: calc(100% - 400px);
    }
  }
`
